import { compose, defaultProps } from '../utils';
import InputPicker from '../InputPicker/InputPicker';
import withLocale from '../IntlProvider/withLocale';
export default compose(withLocale(['Picker', 'InputPicker']), defaultProps({
  multi: true
}))(InputPicker);


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/TagPicker/index.js
// module id = 2335
// module chunks = 35